<template>
    <ul class="bg-skin-b-list-back border-x-2 border-b-2 border-skin-b-list-bord text-skin-b-base rounded-b-lg overflow-y-visible">
        <ListItemLoad v-if="isLoading"/>
        <ListItemEmpty v-else-if="!isLoading&&items.length === 0" :users="users"/>
        <li v-else
            class="odd:bg-skin-b-list-back even:bg-slate-50/50" 
            v-for="(item, index) in items" 
            :key="itemKey ? item[itemKey] : index"
        >
            <slot name="item" :item="item">
            {{ item }}
            </slot>
        </li>
    </ul>
</template>

<script>
import ListItemLoad from './ListItemLoad.vue'
import ListItemEmpty from './ListItemEmpty.vue'

export default {
  name: 'ListBody',
  components: {
    ListItemLoad, ListItemEmpty
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      default: null // If specified, it uses this field for the `:key`
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    users: {
      type: Boolean,
      default: false
    },
  }
};
</script>
